import React from 'react';
export const GuaranteeSection = () => {
  return <section className="bg-biosync-bgTest py-10 px-5 sm:px-10" data-id="element-124">
      <div className="max-w-[800px] mx-auto" data-id="element-125">
        <div className="bg-white border-2 border-biosync rounded-2xl p-8 sm:p-12 text-center shadow-[0_8px_30px_rgba(16,163,127,0.1)]" data-id="element-126">
          <div className="text-6xl mb-6" data-id="element-127">🛡️</div>

          <div className="inline-block bg-biosync text-white font-bold text-sm py-1.5 px-4 rounded-full mb-6" data-id="element-128">
            GARANTÍA BIO-SYNC — 7 DÍAS
          </div>

          <h2 className="text-2xl sm:text-3xl font-bold text-biosync-text mb-6" data-id="element-129">
            "Abrís los módulos.
            <br data-id="element-130" />
            Revisás los bonos.
            <br data-id="element-131" />
            Lo usás con tu adolescente."
          </h2>

          <p className="text-biosync-textSec text-base sm:text-lg mb-8 leading-relaxed max-w-xl mx-auto" data-id="element-132">
            Si en 7 días no es exactamente lo que esperabas:
            <br data-id="element-133" />
            <strong className="text-biosync-text" data-id="element-134">
              Te devolvemos el 100%.
            </strong>
            <br data-id="element-135" />
            Sin preguntas. Sin formularios. Sin drama.
            <br data-id="element-136" />
            <br data-id="element-137" />
            La confianza que tenemos en BIO-SYNC nos permite hacer esa promesa
            sin dudar.
          </p>

          <div className="inline-block bg-biosync/10 text-biosync font-bold text-sm py-2 px-6 rounded-lg" data-id="element-138">
            Tasa de devolución menor al 1%
          </div>
        </div>
      </div>
    </section>;
};